module.exports = __webpack_public_path__ + "static/media/what-peter-griffin.e408d8f9.mp3";